import { useLoaderData, useNavigate, useRevalidator } from "react-router-dom";
import FolderList from "./FolderList";
import DocumentsList from "./DocumentsList";
import { ArrowBack } from "@mui/icons-material";

import Empty from "../../../../ui library/components/data-grid/Empty";
import { Button, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useDocumentListStore } from "../hooks/useDocumentListStore";
import UploadDocuments from "../../UploadDocuments";
import { useHistoryNavigate } from "../../../../../hooks/useHistoryNavigate";

export default function FilesContainer({ customBaseDetailPath }) {
  const { revalidate } = useRevalidator();
  const { _case, folders, managedProviderOptions, title } = useLoaderData();
  const { navigationHistoryService } = useHistoryNavigate();
  const {
    setFolderId,
    parentFolderId,
    isUploadModalOpen,
    setIsUploadModalOpen,
  } = useDocumentListStore();
  const navigate = useNavigate();
  const folderList = folders.folders;
  const documentList = folders.documents;
  const [currentFolder, setCurrentFolder] = useState("");

  useEffect(() => {
    if (!isUploadModalOpen) {
      revalidate();
    }
  }, [isUploadModalOpen]);

  const handleBackArrow = () => {
    setFolderId(parentFolderId);
    revalidate();
  };

  const onClickUpload = () => setIsUploadModalOpen(true);

  const onClickBackToClientDetail = () => {
    if (customBaseDetailPath) {
      navigate(`${customBaseDetailPath}${_case.id}${navigationHistoryService.get("client-detail")}`, { replace: true });
    }
  };

  return (
    <>
      <div className="flex flex-col m-2">
        {folderList.length === 0 && documentList.length === 0 ? (
          <>{Empty}</>
        ) : (
          <>
            <div className="flex flex-row-reverse justify-between w-full">
              {customBaseDetailPath && (
                <Button
                  className="px-4 py-2 mx-2 text-white bg-green-600 hover:bg-green-100 hover:text-green-600"
                  onClick={onClickBackToClientDetail}
                >
                  Back to Client Detail
                </Button>
              )}
              <Button
                className="px-4 py-2 mx-2 text-white bg-blue-600 hover:bg-blue-100 hover:text-blue-600"
                onClick={onClickUpload}
              >
                Upload Document
              </Button>
              {title && (
                <Typography className="flex-1 text-lg font-bold text-center">
                  {title}
                </Typography>
              )}
              {parentFolderId &&
                currentFolder &&
                (folderList.length > 0 || documentList.length > 0) && (
                  <div className="flex flex-row gap-1">
                    <ArrowBack
                      className="hover:cursor-pointer"
                      onClick={handleBackArrow}
                    />
                    <Typography className="flex-1 text-base font-bold text-center">
                      {currentFolder}
                    </Typography>
                  </div>
                )}
            </div>
            {folderList.length > 0 && (
              <FolderList
                _case={_case}
                folders={folderList}
                setCurrentFolder={setCurrentFolder}
              />
            )}
            {documentList.length > 0 && (
              <DocumentsList _case={_case} documents={documentList} />
            )}
          </>
        )}
      </div>
      <UploadDocuments isModal={true} />
    </>
  );
}
